import { HealthcareProviderType } from '@dreryk/egabinet-healthcare-provider-frontend-api';
import { VisitDiagnosis, VisitLocation } from '@dreryk/egabinet-visit-frontend-api';

import { DischargeSummaryFormBean } from './DischargeSummaryForm.types';

export const getDefaultValues = (
   draftValues: DischargeSummaryFormBean | null,
   visitDiagnoses: VisitDiagnosis[] | undefined
): DischargeSummaryFormBean | undefined => {
   const defaultVisitDiagnosis = visitDiagnoses?.length === 1 ? visitDiagnoses[0] : null;
   const defaultDiagnosis = defaultVisitDiagnosis
      ? { code: defaultVisitDiagnosis.icd10Code, name: defaultVisitDiagnosis.name }
      : null;
   if (!draftValues) {
      return {
         diagnosis: defaultDiagnosis,
         diagnosticsGuidelines: null,
         otherGuidelines: null,
         pharmacotherapyGuidelines: null,
         procedurePerformed: null,
         providedMedicalServiceDescription: null,
         specialty: null,
         furtherMedicalTreatmentGuidelines: 'SPECIALIST_CARE_NEEDED',
         medicalDepartment: null,
      };
   }
   return {
      ...draftValues,
      diagnosis:
         draftValues.diagnosis ??
         (defaultVisitDiagnosis ? { code: defaultVisitDiagnosis.icd10Code, name: defaultVisitDiagnosis.name } : null),
   };
};

type HealthcareOrganizationVisitLocationWithFacilityLocation = {
   healthcareFacilityLocationId: number;
   healthcareFacilityUnitId?: never;
};

type HealthcareOrganizationVisitLocationWithFacilityUnit = {
   healthcareFacilityLocationId?: undefined;
   healthcareFacilityUnitId: number;
};

export const isHealthcareOrganization = (
   healthcareProviderType: HealthcareProviderType | undefined,
   visitLocation: VisitLocation
): visitLocation is
   | HealthcareOrganizationVisitLocationWithFacilityLocation
   | HealthcareOrganizationVisitLocationWithFacilityUnit => {
   return healthcareProviderType === 'HEALTHCARE_ORGANIZATION';
};
